
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getMessageBooksCourseList, messageCourseList, getClassAdministrationFriendList, friendItem, createGroup, getTeachTeam } from '@/apis/message/message';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import { Dialog } from 'vant';
import { filterLimitWords } from '@/utils/utils';
import i18n from '@/lang';
// 通讯录
@Component
export default class AddressBooks extends Vue {
  readonly filterLimitWords = filterLimitWords;

  private userName = '';
  private activeNames: string[] = [];
  private classExtendList: string[] = [];
  private teacherTeam: {
    [courseId: string]: Array<friendItem>;
  } = {};

  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  private fullFriendDict: {
    [propName: string]: Array<friendItem>;
  } = {};
  private courseList: Array<messageCourseList> = [];

  getClassMembers(courseId: string, classId: string, ...args: any) {
    console.log(args);
    if (this.fullFriendDict[`${courseId}${classId}`]) {
      return;
    }
    getClassAdministrationFriendList(courseId, classId).then(res => {
      this.fullFriendDict[`${courseId}${classId}`] = res;
      this.$forceUpdate();
    });
  }
  getTeachers(courseId: string) {
    if (this.teacherTeam[courseId] && this.teacherTeam[courseId].length !== 0) {
      this.$forceUpdate();
      return;
    }
    getTeachTeam(courseId).then(res => {
      this.teacherTeam[courseId] = res;
      this.$forceUpdate();
    });
  }
  handlePersonClick(courseid: string, id: string) {
    if (id === this.userInfo.id) {
      Dialog.alert({
        title: i18n.t('Common.系统提示') as string,
        message: i18n.t('message.暂不支持给自己发送私信') as string
      });
      return;
    }
    createGroup({
      friendid: id,
      courseid: courseid
    })
      .then(res => {
        this.$router.push({
          path: '/chat',
          query: {
            groupId: String(res.groupId),
            friendid:id,
            coursename: res.coursename
          }
        });
      })
      .catch(e => {});
  }
  created() {
    getMessageBooksCourseList().then(res => {
      this.courseList = res;
      res.forEach(item => {
        // 初始化所有课程的教师团队
        this.teacherTeam[item.id] = [];
      });
    });
  }
}
